import { Model, model, tProp, types, modelAction } from 'mobx-keystone'
import { ApiModel } from '~api/model/ApiModel'

@model('FareDiscountTier')
export class FareDiscountTier extends ApiModel({
	from_amount: tProp(types.maybe(types.maybeNull(types.number))),
	percentage: tProp(types.maybe(types.maybeNull(types.number))),
	percentage_morning_peak: tProp(types.maybe(types.maybeNull(types.number))),
	percentage_afternoon_peak: tProp(types.maybe(types.maybeNull(types.number))),
	percentage_outside_peak: tProp(types.maybe(types.maybeNull(types.number))),
}) {}

export enum UseRate {
	Discounted = 'Discounted',
	Full = 'Full',
}

@model('FareDiscount')
export class FareDiscount extends ApiModel({
	use_rate: tProp(types.maybe(types.maybeNull(types.enum(UseRate)))),
	tiers: tProp(types.array(types.model<FareDiscountTier>(FareDiscountTier)), () => []),
}) {
	@modelAction
	addTier() {
		this.tiers.push(new FareDiscountTier({}))
	}

	@modelAction
	removeTier(index: number) {
		if (this.tiers.length > 1) {
			this.tiers.splice(index, 1)
		}
	}
}
